import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';

const fmtM = (n) => (n == null ? 'a confirmar' : `${Number(n).toFixed(2).replace('.', ',')} m`);

export default function SuccessPage() {
  const { state } = useLocation();
  const request = state?.request;
  const number = request?.id || 1058;

  return (
    <main className="mx-auto max-w-2xl px-4 py-14 md:py-16" data-testid="success-page">
      <div className="text-center">
        <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-600" strokeWidth={1.5} />
        <h1 className="mt-5 font-serif text-3xl tracking-tight text-navy md:text-4xl" data-testid="success-title">
          Solicitação enviada com sucesso
        </h1>
        <p className="mt-3 inline-block rounded-full bg-navy-light px-5 py-2 font-serif text-xl text-navy" data-testid="success-request-number">
          Solicitação #{number}
        </p>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-muted-foreground" data-testid="success-message">
          Sua solicitação já foi enviada com sucesso. Aguarde nosso contato pelo WhatsApp informado —
          nossa equipe verificará a disponibilidade dos tecidos, as quantidades e os valores.
        </p>
      </div>

      {request && (
        <section className="mt-10" aria-label="Resumo da sua solicitação">
          <h2 className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground" data-testid="success-summary-title">
            Resumo da sua solicitação
          </h2>
          <ul className="mt-4 space-y-3" data-testid="success-summary">
            {request.items.map((i, idx) => (
              <li
                key={`${i.productSlug || i.slug}-${i.variantId}-${idx}`}
                className="flex items-center gap-4 rounded-2xl border border-navy/10 bg-white p-4 text-left shadow-sm"
                data-testid={`success-item-${idx}`}
              >
                {i.image && (
                  <img
                    src={i.image}
                    alt={i.variantName ? `${i.name} - ${i.variantName}` : i.name}
                    className="h-16 w-16 shrink-0 rounded-xl object-cover"
                    loading="lazy"
                  />
                )}
                <div className="min-w-0">
                  <p className="truncate font-medium text-navy">{i.name}</p>
                  {i.variantName && <p className="truncate text-sm text-muted-foreground">{i.variantName}</p>}
                  <p className="mt-1 text-sm">
                    Metragem solicitada: <strong>{fmtM(i.meters)}</strong>
                  </p>
                </div>
              </li>
            ))}
          </ul>
          <p className="mt-3 text-center text-xs text-muted-foreground" data-testid="success-no-price-note">
            Os valores serão informados pelo vendedor após a confirmação de disponibilidade.
          </p>
        </section>
      )}

      <div className="mt-10 flex justify-center">
        <Link
          to="/categoria/todos"
          className="flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-sm font-semibold text-white hover:bg-navy-hover"
          data-testid="success-continue-button"
        >
          CONTINUAR EXPLORANDO <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </main>
  );
}
